import React, { useState, useEffect } from 'react';
import logo from '../images/sadhimalogo-desktop.png';
import { useAuth } from '../screens/Authcontext';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const Login = () => {
    const [loginId, setLoginId] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login, isLoggedIn, role } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            // Redirect based on role
            if (role === 'USER') {
                navigate('/profile');
            } else {
                navigate('/dashboard');
            }
        }
    }, [isLoggedIn, role, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Auto-detect: if contains @ it's email (admin), otherwise mobile (user)
        const isEmail = loginId.includes('@');
        
        const result = await login(
            isEmail ? loginId : null, 
            isEmail ? null : loginId, 
            password
        );

        setIsLoading(false);

        if (!result.success) {
            toast.error(result.error || 'Invalid Credentials');
        }
        // Success → useEffect will redirect based on role
    };

    return (
        <>
            <ToastContainer />
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img className="mx-auto h-10 w-auto" src={logo} alt="Your Company" />
                    <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Sign in to your account
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                    <form className="space-y-6" onSubmit={handleLogin}>
                        <div>
                            <label htmlFor="loginId" className="block text-sm font-medium text-gray-900">
                                Email or Mobile Number
                            </label>
                            <input
                                id="loginId"
                                type="text"
                                value={loginId}
                                onChange={(e) => setLoginId(e.target.value)}
                                placeholder="Enter email or mobile number"
                                required
                                disabled={isLoading}
                                className="mt-2 block w-full rounded-md px-3 py-1.5 text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-red-400 disabled:bg-gray-100"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                                Password
                            </label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={isLoading}
                                className="mt-2 block w-full rounded-md px-3 py-1.5 text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-red-400 disabled:bg-gray-100"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full rounded-md bg-red-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-red-500 disabled:bg-red-300 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Signing in...' : 'Sign in'}
                        </button>
                    </form>

                    <p className="mt-6 text-center text-xs text-gray-500">
                        Admin: Use email | User: Use mobile number
                    </p>
                </div>
            </div>
        </>
    );
};

export default Login;
